<template>
    <home-upcoming-events/>
    <home-news/>
    <home-info-raii/>
    <home-goals-raii/>
    <home-partners/>
    <home-useful/>
</template>
<script>
import HomeUpcomingEvents from '@/components/upcomingEvents/HomeUpcomingEvents.vue'
import HomeNews from '@/components/news/HomeNews.vue'
import HomeGoalsRaii from '@/components/goalsRaii/HomeGoalsRaii.vue'
import HomeInfoRaii from '@/components/infoRaii/HomeInfoRaii.vue';
import HomePartners from '@/components/partners/HomePartners.vue';
import HomeUseful from '@/components/useful/HomeUseful.vue';

export default{
    name: 'HomePage',
    components: {
        HomeUpcomingEvents,
        HomeNews,
        HomeInfoRaii,
        HomeGoalsRaii,
        HomePartners,
        HomeUseful
    }
}
</script>
